import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchTerritory, createTerritory, updateTerritory } from './actions';
import TerritorySettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleTerritorySettingsSubmit = this.handleTerritorySettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { match, fetchTerritory } = this.props;
		const territoryId = match.params.territoryId;

		if (territoryId) {
			fetchTerritory(territoryId);
		}
	}

	handleTerritorySettingsSubmit(values) {
		const { history, franchiseeId, territory, createTerritory, updateTerritory } = this.props;

		Object.assign(values, { franchiseeId });
		if (territory) {
			updateTerritory(territory.id, values);
		} else {
			createTerritory(values, history);
		}
	}

	render() {
		const { franchiseeId, territory, isReadonly, t } = this.props;

		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<TerritorySettingsForm franchiseeId={franchiseeId} onSubmit={this.handleTerritorySettingsSubmit} initialValues={territory} isReadonly={isReadonly} />
			</Panel.Body>
		</Panel >;
	}
};

const mapStateToProps = (state, ownProps) => {
	const territoryId = ownProps.match.params.territoryId;

	const {
		auth: { currentUser },
		entities: { territories }
	} = state;

	return {
		territory: territories[territoryId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Franchisees')
	};
};

export default connect(mapStateToProps, {
	fetchTerritory,
	createTerritory,
	updateTerritory
})(withTranslation()(Details));